<template>
  <div id="top" class="mainWrapper">
    <!--nav-->
    <head-nav v-bind:gray="gray" v-bind:pos="'fixed'"></head-nav>
    <!--container-->
    <div class="innerWrapper">
      <h1 style="margin-left:0.32rem">Bookmarked properties</h1>
      <div
        v-if="total == 0"
        style="padding-top:80px;text-align:center;font-size:18px;color:#3F3F46;margin-bottom:218px"
      >
        No data.
      </div>
      <pagination
        v-if="total !== 0"
        :cur="pageCur"
        v-bind:total="total"
        @accept="page"
      ></pagination>
      <ul v-if="total !== 0">
        <li>
          <item
            v-for="(item, index) in datum.formatList"
            :key="index"
            :btnNum="index + 1"
            :datum="item"
            @accept="collectOperate"
          ></item>
        </li>
      </ul>
      <pagination
        v-if="total !== 0"
        :cur="pageCur"
        v-bind:total="total"
        @accept="page"
      ></pagination>
    </div>
    <!--footer-->
    <foot-nav></foot-nav>
  </div>
</template>

<script>
import headNav from "@/components/package/nav";
import footNav from "@/components/package/footer";
import item from "@/components/package/item";
import pagination from "@/components/package/pagination";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  data() {
    return {
      gray: true,
      hidePrice: false,
      pageCur: 1,
      pageSize: 8,
      total: 0
    };
  },
  created() {
    var that = this;
    that.getLst({
      params: { page: that.pageCur, pageSize: that.pageSize },
      callback: that.callback
    });
  },
  mounted() {
    document.getElementById("top").scrollIntoView();
  },
  methods: {
    collectOperate(type, id) {
      var that = this;
      that.cancelCollect({
        params: { propertyId: id },
        callback: that.cancelCallback
      });
    },
    cancelCallback(res, id) {
      var that = this;
      if (res.data.code == 0) {
        that.collect({ data: { type: "yes", id: id } });
        console.log(this.datum);
        that.$forceUpdate();
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      }
    },
    ...mapActions("home", ["cancelCollect"]),
    ...mapActions("book", ["getLst"]),
    ...mapMutations("book", ["setLst", "collect"]),
    callback(res) {
      var that = this;
      if (res.data.code == 0) {
        // 统一把列表格式化
        res.data.data.formatList = [];
        that.total = res.data.data.totalRecord;
        res.data.data.list.forEach(v => {
          if (v.housePropertyPOJO == null) {
            return;
          }
          if (v.housePropertyPOJO.imageUrl) {
            if (v.housePropertyPOJO.imageUrl.indexOf(",") !== -1) {
              v.housePropertyPOJO.imgLst = v.housePropertyPOJO.imageUrl.split(
                ","
              );
            } else {
              v.housePropertyPOJO.imgLst = [v.housePropertyPOJO.imageUrl];
            }
          }
          res.data.data.formatList.push({
            propertyId: v.housePropertyPOJO.propertyId,
            imgLst: v.housePropertyPOJO.imgLst,
            address: v.housePropertyPOJO.address,
            suburb: v.housePropertyPOJO.suburb,
            price: that.$box.formatSplit(v.housePropertyPOJO.price, true),
            maxRental:
              v.housePropertyPOJO.maxRental !== 0
                ? that.$box.formatSplit(v.housePropertyPOJO.maxRental, true)
                : null,
            maxPrice:
              v.housePropertyPOJO.maxPrice !== ""
                ? that.$box.formatSplit(v.housePropertyPOJO.maxPrice, true)
                : "",
            rental: that.$box.formatSplit(v.housePropertyPOJO.rental, true),
            rentalYield: v.housePropertyPOJO.rentalYield,
            commision: that.$box.formatSplit(
              parseInt(v.housePropertyPOJO.commission),
              true
            ),
            // maxCommision: (v.housePropertyPOJO.proertyType == 'Apartments  Units' || v.housePropertyPOJO.proertyType =='Townhouses') !== '' ? that.$box.formatSplit(v.housePropertyPOJO.maxCommision, true) : '',
            maxCommision:
              v.housePropertyPOJO.maxCommision !== ""
                ? that.$box.formatSplit(
                    parseInt(v.housePropertyPOJO.maxCommision),
                    true
                  )
                : "",
            bedsNumber: v.housePropertyPOJO.bedsNumber,
            favoritesFlag: v.favoritesFlag,
            proertyType: v.housePropertyPOJO.proertyType,
            state: v.housePropertyPOJO.state,
            postcode: v.housePropertyPOJO.postcode,
            // 再传一个状态判断，是否被别人购买/预定，且无剩余可购买/预定，且本身无购买/预定该房产，如果true，就不能点击了 8848
            clickFlag: v.clickFlag,
            // 再多传一个，区分已预订 / 未预定购买
            operate: v.housePropertyPOJO.sellFlag == "0" ? 0 : 1,
            estimatedCompletion: v.housePropertyPOJO.estimatedCompletion,
            estimatedCommenceMent: v.housePropertyPOJO.estimatedCommenceMent,
            landPrice:
              v.housePropertyPOJO.landPrice !== ""
                ? that.$box.formatSplit(v.housePropertyPOJO.landPrice, true)
                : "",
            buildPrice:
              v.housePropertyPOJO.buildPrice !== ""
                ? that.$box.formatSplit(v.housePropertyPOJO.buildPrice, true)
                : "",
            incentives: v.housePropertyPOJO.incentives
          });
        });
        that.setLst({ data: res.data.data });
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      }
    },
    page(p) {
      var that = this;
      that.pageCur = p;
      that.getLst({
        params: { page: that.pageCur, pageSize: that.pageSize },
        callback: that.callback
      });
      document.getElementById("top").scrollIntoView();
    }
  },
  components: {
    headNav,
    footNav,
    item,
    pagination
  },
  computed: mapState({
    datum: state => state.book.list
  })
};
</script>

<style lang="scss" scoped>
.mainWrapper {
  width: 100%;
  position: relative;
}

.innerWrapper {
  width: 100%;
  margin: 0 auto;
  padding-top: 1.52rem;
  box-sizing: border-box;

  h1 {
    font-size: 0.56rem;
    color: #2a2929;
    line-height: 0.68rem;
    margin-bottom: 0.8rem;
    font-family: ProximaNova-Semibold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/book.vue